export function getGeoMetadata(schema) {
  const geoMetadata = parseJSONStringMetadata(schema, 'geo');
  if (!geoMetadata) {
    return null;
  }
  for (const column of Object.values(geoMetadata.columns || {})) {
    if (column.encoding) {
      column.encoding = column.encoding.toLowerCase();
    }
  }
  return geoMetadata;
}
export function setGeoMetadata(schema, geoMetadata) {
  const stringifiedGeoMetadata = JSON.stringify(geoMetadata);
  schema.metadata.geo = stringifiedGeoMetadata;
}
export function unpackGeoMetadata(schema) {
  const geoMetadata = getGeoMetadata(schema);
  if (!geoMetadata) {
    return;
  }
  const {
    version,
    primary_column,
    columns
  } = geoMetadata;
  if (version) {
    schema.metadata['geo.version'] = version;
  }
  if (primary_column) {
    schema.metadata['geo.primary_column'] = primary_column;
  }
  schema.metadata['geo.columns'] = Object.keys(columns || {}).join('');
  for (const [columnName, columnMetadata] of Object.entries(columns || {})) {
    const field = schema.fields.find(field => field.name === columnName);
    if (field) {
      if (field.name === primary_column) {
        setFieldMetadata(field, 'geo.primary_field', 'true');
      }
      unpackGeoFieldMetadata(field, columnMetadata);
    }
  }
}
function unpackGeoFieldMetadata(field, columnMetadata) {
  for (const [key, value] of Object.entries(columnMetadata || {})) {
    switch (key) {
      case 'geometry_types':
        setFieldMetadata(field, `geo.${key}`, value.join(','));
        break;
      case 'bbox':
        setFieldMetadata(field, `geo.crs.${key}`, JSON.stringify(value));
        break;
      case 'crs':
        for (const [crsKey, crsValue] of Object.entries(value || {})) {
          switch (crsKey) {
            case 'id':
              const crsId = typeof crsValue === 'object' ? `${crsValue === null || crsValue === void 0 ? void 0 : crsValue.authority}:${crsValue === null || crsValue === void 0 ? void 0 : crsValue.code}` : JSON.stringify(crsValue);
              setFieldMetadata(field, `geo.crs.${crsKey}`, crsId);
              break;
            default:
              setFieldMetadata(field, `geo.crs.${crsKey}`, typeof crsValue === 'string' ? crsValue : JSON.stringify(crsValue));
              break;
          }
        }
        break;
      case 'edges':
      default:
        setFieldMetadata(field, `geo.${key}`, typeof value === 'string' ? value : JSON.stringify(value));
    }
  }
}
function setFieldMetadata(field, key, value) {
  field.metadata = field.metadata || {};
  field.metadata[key] = value;
}
export function parseJSONStringMetadata(schema, metadataKey) {
  const stringifiedMetadata = schema.metadata[metadataKey];
  if (!stringifiedMetadata) {
    return null;
  }
  try {
    const metadata = JSON.parse(stringifiedMetadata);
    if (!metadata || typeof metadata !== 'object') {
      return null;
    }
    return metadata;
  } catch {
    return null;
  }
}
export function unpackJSONStringMetadata(schema, metadataKey) {
  const json = parseJSONStringMetadata(schema, metadataKey);
  for (const [key, value] of Object.entries(json || {})) {
    schema.metadata[`${metadataKey}.${key}`] = typeof value === 'string' ? value : JSON.stringify(value);
  }
}
//# sourceMappingURL=geoparquet-metadata.js.map